import authHttp, { API_ROOT } from '../services/auth-http'

export const PortfoliosService = {
    getPortfolios() {
        return authHttp.get(`${API_ROOT}/public/portfolios`)
    }
}

export default PortfoliosService